import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 40px 38px 40px 40px;
  border-radius: 2px;
  color: ${({ theme }) => theme.palette.darkGrey};
  box-shadow: 0 10px 20px 0 rgba(58, 58, 58, 0.1);
  position: relative;
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 20px 0;
    padding: 23px 15px 20px 15px;
  }
`;
export const StyledBoxItemContent = styled.div`
  margin-left: 16px;
`;
export const StyledBoxItemLabel = styled.span`
  font-size: 18px;
  display: block;
`;
export const StyledBoxItemText = styled.span`
  font-size: 18px;
  font-weight: bold;
`;
export const StyledBoxItem = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  &:first-of-type {
    margin-right: 40px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 10px 0;
    text-align: left;
  }
`;
export const StyledBody = styled.div`
  padding: 20px;
  display: flex;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    top: 0;
    left: 15px;
    width: 100%;
    background-color: ${({ theme }) => theme.palette.white};
    border-bottom: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};
    padding-bottom: 30px;
    padding-right: 30px;
  }
`;
export const StyledHeader = styled.div`
  width: 100%;
  display: flex;
  z-index: 99999;
  align-items: center;
  margin-bottom: 30px;
  padding-top: 20px;
`;

export const StyledHeaderLabel = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGrey};
  letter-spacing: 1px;
  margin-right: auto;
`;
export const Title = styled.span`
  font-size: 24px;
  font-weight: bold;

  color: ${({ theme }) => theme.palette.darkGrey};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
  }
`;
export const StyledBoxFooter = styled.div`
  width: 100%;
  margin: 40px auto 0 auto;
  padding: 40px 0 0 0;
  border-top: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    border: none;
  }
`;

export const StyledBoxFooterContent = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 100%;
  }
`;
export const StyledBoxFooterItem = styled.div`
  margin-bottom: 40px;
`;

export const StyledBoxFooterTitle = styled.span`
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
  display: block;
`;

export const Section = styled.div`
  & span {
    display: flex;
    justify-content: flex-start;
    text-decoration: underline;
  }
`;

export const StyledBoxFooterDesc = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.darkGrey};
`;
